import {Modal} from "antd";
import {useTranslation} from "react-i18next";

export default function JsonViewModal({visible, data, onClose, title})
{
    const {t} = useTranslation();
    
    const formatJson = (data) => {
        if (!data) return '';
        try {
            // If data is a string, try to parse it first
            const parsed = typeof data === 'string' ? JSON.parse(data) : data;
            return JSON.stringify(parsed, null, 2);
        } catch (e) {
            // If parsing fails, return as-is
            return typeof data === 'string' ? data : JSON.stringify(data, null, 2);
        }
    };
    
    return (
        <Modal
            title={title || t('JSON Data')}
            open={visible}
            onCancel={onClose}
            footer={null}
            width={800}
        >
            <pre style={{
                maxHeight: '60vh', 
                overflow: 'auto',
                backgroundColor: '#f5f5f5',
                padding: 12,
                borderRadius: 4,
                fontSize: 12
            }}>
                {formatJson(data)}
            </pre>
        </Modal>
    )
}
